import type { Schemas } from '@beamx/shared';
import { request } from './client.js';

/** Individual event flags the API accepts in a webhook subscription. */
export const WEBHOOK_EVENTS = [
  'Processed',
  'Deferred',
  'Delivered',
  'HardBounce',
  'SoftBounce',
  'Dropped',
  'SpamReport',
  'Opened',
  'Clicked',
  'Unsubscribed',
] as const;

export type WebhookEvent = (typeof WEBHOOK_EVENTS)[number];

// Response types derive from the backend OpenAPI contract (generated schema.d.ts).
export type WebhookSummary = Schemas['WebhookSummary'];
export type RegisterWebhookResult = Schemas['RegisterWebhookResult'];
export type RotateWebhookSecretResult = Schemas['RotateWebhookSecretResult'];

export const webhooks = {
  list: () => request<WebhookSummary[]>('/v1/webhooks'),

  register: (body: { url: string; name: string; events: string[] }) =>
    request<RegisterWebhookResult>('/v1/webhooks', { method: 'POST', body }),

  rotateSecret: (id: string) =>
    request<RotateWebhookSecretResult>(`/v1/webhooks/${id}/rotate-secret`, { method: 'POST' }),
};
